<template>
  <div class="chat-bot-holder-outer">
    <div class="chat-bot-holder-inner">
      <div
        @click="openChatBot"
        class="chat-bot-wrapper"
        :class="{ active: open }"
      >
        <div v-show="!open" class="icon">
          <img class="bounce" src="@/assets/images/chatBotIcon.png" alt="" />
        </div>
        <div v-show="open" class="chat-bot">
          <div class="top-wrapper">
            <div class="logo-white-wrapper">
              <img
                src="@/assets/newImges/new-logo.png"
                class="logo-white"
                alt="logo image"
              />
            </div>
            <div class="top-user-wrapper">
              <div class="name">{{ $t("chatBot.Assistant") }}</div>
              <div class="status">Online</div>
            </div>
            <img
              src="@/assets/images/chatBotClose.png"
              style="margin-left: auto; cursor: pointer;"
              class="close"
              alt="close btn"
              @click="closeChatBot"
            />
          </div>
          <div v-if="show" class="messages-wrapper">
            <chat-bot-message
              v-for="(message, index) in messages"
              :key="index"
              :messageData="message"
              :interval="!render"
              @optionSelected="optionSelected"
            />
          </div>
          <div v-else class="messages-wrapper" style="justify-content: center;">
            <div class="initial-messag">
              <span>{{ $t("chatBot.helloMsg") }}</span>
              <div class="btn" @click="startChat">
                {{ $t("chatBot.startSearch") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import chatBotMessage from "./chat-bot-message.vue";
import { api } from "@/api";
import { nextTick } from "process";
export default {
  name: "chat-bot-wrapper",
  components: {
    chatBotMessage
  },
  data() {
    return {
      open: false,
      messages: [],
      show: false,
      render: true
    };
  },
  mounted() {
    this.getMessage();
  },
  methods: {
    openChatBot() {
      this.open = true;
    },
    closeChatBot(e) {
      this.open = false;
      e.stopPropagation();
    },
    startChat() {
      this.show = true;
    },
    async getMessage(messageId = null) {
      try {
        let res = await api.getChatbotMessage(messageId);
        res.data.data.author = "asistent";
        this.messages.push(res.data.data);
        await nextTick;
        this.scrollToBottom();
      } catch (error) {
        console.log(error);
      }
    },
    optionSelected(option) {
      let userMessage = {
        text: option.label
      };
      this.messages.push(userMessage);
      this.getMessage(option.id);
    },
    scrollToBottom() {
      let el = document.querySelector(".messages-wrapper");
      el.scrollTo({ top: el.scrollHeight, behavior: "smooth" });
    }
  },
  computed: {
    activeLocale() {
      return this.$i18n.locale;
      // return "sr";
    }
  },
  watch: {
    "$route.params.lang": {
      handler: function() {
        let help = this.messages;
        this.messages = [];
        this.render = false;
        setTimeout(() => {
          this.messages = help;
        }, 10);
        setTimeout(() => {
          this.render = true;
        }, 100);
      }
    }
  }
};
</script>
<style lang="scss">
.chat-bot-holder-outer {
  position: fixed;
  width: 100%;
  z-index: 3;
  bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  pointer-events: none;

  .chat-bot-holder-inner {
    width: calc(100% - 40px);
    margin: 0 auto;
    display: flex;
    justify-content: flex-end;

    .chat-bot-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 83px;
      width: 83px;
      border-radius: 50%;
      z-index: 5;
      cursor: pointer;
      transition-duration: 0.2s;
      pointer-events: all;
    }
    .chat-bot-wrapper.active {
      width: 400px;
      height: 610px;
      border-radius: 9px;
      overflow: hidden;
      background: #ffffff;
      box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
      cursor: unset;

      .chat-bot {
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;

        .top-wrapper {
          box-sizing: border-box;
          padding: 0 20px;
          min-height: 53px;
          display: flex;
          justify-content: center;
          align-items: center;
          background: #823a4c;

          .logo-white {
            height: 20px;
          }
          .logo-white-wrapper {
            position: relative;
          }
          .logo-white-wrapper::after {
            content: "";
            display: block;
            position: absolute;
            min-height: 9px;
            min-width: 9px;
            background: #69de40;
            right: -5px; //-3px;
            top: 0px; // 3px;
            border-radius: 50%;
          }
          .top-user-wrapper {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            margin-left: 13px;

            .name {
              font-weight: 700;
              font-size: 12px;
              line-height: 16px;
              color: #bdb7b7;
            }
            .status {
              font-weight: 400;
              font-size: 10px;
              line-height: 16px;
              color: #bdb7b7;
            }
          }
        }

        .messages-wrapper {
          flex-grow: 1;
          margin: 10px 24px;
          margin-right: 5px;
          padding-right: 19px;
          box-sizing: border-box;
          overflow: auto;
          display: flex;
          flex-direction: column;
          @import "@/assets/scss/scrollbarStyles.scss";
          @include scrollbar;

          .initial-messag {
            padding: 10px 20px;
            border-radius: 9px;
            margin-bottom: 17px;
            font-weight: 400;
            font-size: 16px;
            line-height: 20px;
            color: #3f3f3f;
            background: #fff6f6;
            border: 1px solid #823a4c;

            .btn {
              margin-top: 20px;
              font-weight: 600;
              font-size: 16px;
              line-height: 20px;
              text-align: center;
              color: #fff6f6;
              text-transform: unset;
              border-radius: 3px;
            }
          }
        }
      }
    }
  }
}
.bounce {
  position: fixed;
  z-index: 2;
  right: 20px;
  bottom: 20px;
  cursor: pointer;
  animation-name: bounce-7;
  animation-timing-function: cubic-bezier(0.28, 0.84, 0.42, 1);
  animation-duration: 2s;
  animation-iteration-count: infinite;
  transform-origin: bottom;
}
@keyframes bounce-7 {
  0% {
    transform: scale(1, 1) translateY(0);
  }
  10% {
    transform: scale(1.1, 0.9) translateY(0);
  }
  30% {
    transform: scale(0.9, 1.1) translateY(-30px);
  }
  40% {
    transform: scale(1.05, 0.95) translateY(0);
  }
  47% {
    transform: scale(1, 1) translateY(-7px);
  }
  64% {
    transform: scale(1, 1) translateY(0);
  }
  100% {
    transform: scale(1, 1) translateY(0);
  }
}
</style>
